/**
 * Client-side env parsing. Only VITE_* vars are safe here — anything else is
 * server-only and would be undefined at runtime.
 */

import { z } from 'zod';

const schema = z.object({
  VITE_API_BASE_URL: z.string().default(''),
});

export const env = schema.parse(import.meta.env);
